import React from 'react';
const CapitalOne = () => {
  return (
    <svg
      fill='#000000'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 55 55'
      width='40px'
      height='40px'
    >
      <path d='M25,2C12.317,2,2,12.318,2,25s10.317,23,23,23s23-10.318,23-23S37.683,2,25,2z M4,25c0-1.967,0.292-3.865,0.8-5.672	c7.318-0.92,15.095,0.302,17.783,1.549c1.321,0.613,2.363,1.777,2.858,3.196c0.506,1.446,0.387,3.037-0.336,4.479	c-1.306,2.607-6.261,7.152-13.615,12.501C6.917,37.198,4,31.436,4,25z M25,46c-3.189,0-6.203-0.736-8.913-2.013	c9.269-5.248,16.542-10.866,23.347-18.065c3.147-3.329,3.839-6.673,1.896-9.175c-1.916-2.468-4.91-2.896-6.188-3.078	c-8.428-1.204-16.708-0.909-27.838,0.071C11.036,7.895,17.565,4,25,4c11.579,0,21,9.42,21,21S36.579,46,25,46z' />
    </svg>
  );
};
export default CapitalOne;
